var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-wrapper"},[_c('inline-svg',{attrs:{"src":_vm.theme.logo.src},on:{"loaded":_vm.handleLogoLoad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }